const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/audit-logs.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/audit-logs')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/* ─── Types ───────────────────────────────────────────────────────────────── */

interface AuditLog {
  id: string;
  businessId: string;
  actorClerkId: string;
  actorName: string;
  action: string;
  entityType: string;
  entityId: string | null;
  details: Record<string, unknown> | null;
  ipAddress: string | null;
  createdAt: string;
}
interface Pagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

/* ─── Action colors & labels ──────────────────────────────────────────────── */

/* ─── Unique action values for filter ─────────────────────────────────────── */

/* ─── Component ───────────────────────────────────────────────────────────── */